import React from 'react';
import { useParams } from 'react-router-dom';

import AdminBrowseHomeEditPage from 'app/components/admin/browse/home/AdminBrowseHomeEditPage';

export function AdminBrowseHomeEditPageRoute() {
  const { browseHomePageId } = useParams();

  return <AdminBrowseHomeEditPage browseHomePageId={browseHomePageId} />;
}

export default AdminBrowseHomeEditPageRoute;
